import HttpClient from "utils/HttpClient/HttpClient"
import { SUCCESSFUL_GET_ACCOUNT, SUCCESSFUL_GET_ACCOUNT_BALANCE } from "./actionConst";
import { SHOW_ERROR_MESSAGE } from 'reducers/application/actionConst';

export const fetchAccountInfo = () => dispatch => {   
    new HttpClient(true).get("b2c/account")
        .then((response) => {
            console.log("Successful Fetch Account");
            dispatch({
                type: SUCCESSFUL_GET_ACCOUNT,
                payload: response.data
            });
        })
        .catch((error) => {
            console.log("Failed Fetch Account");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        })


}

export const fetchAccountBalance = () => dispatch => {   
    new HttpClient(true).get("b2c/account/balance")
        .then((response) => {
            console.log("Successful Fetch Account Balance");
            dispatch({
                type: SUCCESSFUL_GET_ACCOUNT_BALANCE,
                payload: response.data
            });
        })
        .catch((error) => {
            console.log("Failed Fetch Account Balance");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        })


}


// WEBPACK FOOTER //
// ./src/reducers/account/accountActions.js